declare global {
  // eslint-disable-next-line no-var
  var __webpack_public_path__: string | undefined;
}

/**
 * Derive the webpack public path from a worker script URL served under /chunks/.
 */
export function deriveWorkerPublicPathFromScriptLocation(
  href: string
): string | undefined {
  const marker = '/chunks/';
  const index = href.lastIndexOf(marker);
  if (index < 0) {
    return undefined;
  }
  return href.slice(0, index + 1);
}

export function applyWorkerPublicPath(publicPath: string): void {
  const normalized = publicPath.endsWith('/') ? publicPath : `${publicPath}/`;
  globalThis.__webpack_public_path__ = normalized;
}

/**
 * Bootstrap worker chunk loading before rspack importScripts pulls shared chunks.
 * Post-emit build patching prepends the same logic; this covers dev and late loads.
 */
export function bootstrapWorkerPublicPathFromScriptLocation(href?: string): void {
  const scriptHref =
    href ?? (typeof self !== 'undefined' && self.location?.href ? self.location.href : '');
  if (!scriptHref) {
    return;
  }

  const existing = globalThis.__webpack_public_path__;
  if (typeof existing === 'string' && existing.length > 0) {
    return;
  }

  const derived = deriveWorkerPublicPathFromScriptLocation(scriptHref);
  if (derived) {
    applyWorkerPublicPath(derived);
  }
}
